var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { GoogleOAuthProvider } from '@react-oauth/google';
import Installation from '@web/components/Onboarding/Installation';
import { GOOGLE_CLIENT_ID } from '@web/config';
import { UserContext } from '@web/contexts/User';
import { Page } from '@web/pages/layout/Page';
import { dashboardUrl } from '@web/router/urls';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
export var InstallationView = function () {
    var currentUser = useContext(UserContext).currentUser;
    if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.workspace) {
        return _jsx(Navigate, { to: dashboardUrl });
    }
    return (_jsx(Page, { children: _jsx(GoogleOAuthProvider, __assign({ clientId: GOOGLE_CLIENT_ID }, { children: _jsx(Installation, {}) })) }));
};
